import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProdutoSaidaService {
  private data = null;
  private url = environment.serviceApi;
  constructor(public http: Http) { }

  getProdutoSaidas() {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/produtosaida')
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getProdutoSaida(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/produtosaida/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  criaProdutoSaida(data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.url + '/produtosaida', {
        produto_id: data.produto_id,
        usuario_id: data.usuario_id,
        unidade_id: data.unidade_id,
        cliente_id: data.cliente_id,
        produto_saida_quantidade: data.produto_saida_quantidade,
        produto_saida_data: data.produto_saida_data,
        produto_saida_data_gravacao: data.produto_saida_data_gravacao,
        produto_saida_pedido: data.produto_saida_pedido,
        produto_saida_valor_unit: data.produto_saida_valor_unit
      })
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  editaProdutoSaida(data) {
    return new Promise((resolve, reject) => {
      this.http.put(this.url + '/produtosaida/' + data.produto_saida_id, {
        produto_id: data.produto_id,
        usuario_id: data.usuario_id,
        unidade_id: data.unidade_id,
        cliente_id: data.cliente_id,
        produto_saida_quantidade: data.produto_saida_quantidade,
        produto_saida_data: data.produto_saida_data,
        produto_saida_data_gravacao: data.produto_saida_data_gravacao,
        produto_saida_pedido: data.produto_saida_pedido,
        produto_saida_valor_unit: data.produto_saida_valor_unit
      })
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  apagaProdutoSaida(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(this.url + '/produtosaida/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }
}
